import type { SubQuestion } from './reviewTypes';
import {
  EMPTY_TASK_DETAILS,
  toTaskDetails,
  stripTaskDetails,
} from '../../../shared/domain/taskDetailsValidation';

/**
 * Sub-question task helpers. The task value transforms are shared with the
 * audit-criteria step (one implementation in
 * {@link shared/domain/taskDetailsValidation}); this module just re-exports
 * them and binds the container-generic `stripTaskDetails` to the SubQuestion
 * shape so existing call sites keep their names.
 */

export { EMPTY_TASK_DETAILS, toTaskDetails };

/** Returns the sub-question without its `taskDetails` key (rather than setting
 *  it to `undefined`) so it stays clean under exactOptionalPropertyTypes. Thin
 *  binding of the shared, container-generic {@link stripTaskDetails}. */
export function stripTask(sub: SubQuestion): SubQuestion {
  return stripTaskDetails(sub);
}
